import React from 'react';
import { Filter } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
interface FilterFloatingButtonProps {
  onClick: () => void;
  activeFiltersCount: number;
}
export const FilterFloatingButton: React.FC<FilterFloatingButtonProps> = ({
  onClick,
  activeFiltersCount
}) => {
  return <div className="fixed bottom-20 right-4 z-40 md:bottom-6">
      <Button onClick={onClick} size="lg" className="h-14 w-14 rounded-full shadow-lg relative bg-luxury-pinkBright">
        <Filter className="h-6 w-6" />
        {activeFiltersCount > 0 && <Badge className="absolute -top-2 -right-2 h-6 w-6 rounded-full p-0 flex items-center justify-center bg-luxury-gold text-black text-xs font-bold">
            {activeFiltersCount}
          </Badge>}
      </Button>
    </div>;
};